import { render, staticRenderFns } from "./orderCourier.vue?vue&type=template&id=511714a3&scoped=true&"
import script from "./orderCourier.vue?vue&type=script&lang=js&"
export * from "./orderCourier.vue?vue&type=script&lang=js&"
import style0 from "./orderCourier.vue?vue&type=style&index=0&id=511714a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511714a3",
  null
  
)

export default component.exports